module.exports = {
  app: {
    title: "Hommey Website",
    description: "Hommey Website by DotDev",
    url: "https://gethommey.com",
    logo: "static/favicons/Cushion.svg",
    themeColor: "#000000",
    themeBackground: "#FFFF04",
    themeDisplay: "minimal-ui",
    themeIcon: "static/favicons/Hommey_Favicon.gif",
  },
  stores: {
    "hommey-store": {
      siteLocation: "AU",
      siteCountries: "AU",
      shopName: "hommey-store",
      shopDomain: "checkout.gethommey.com",
      accessToken: "fc230763d8722ce79f597a6b55cc1204",
      adminAccessToken: process.env.GATSBY_SHOPIFY_ADMIN_API,
      shopifyPlus: false,
      sanityDataset: process.env.GATSBY_SANITY_DEFAULT_DATASET,
      searchIndex: "hommey-search-v2",
    },
  },
  services: {
    shopify: {
      apiVersion: "2020-07",
      defaultShopName: process.env.GATSBY_SHOPIFY_DEFAULT_SHOP,
    },
    sanity: {
      projectId: "5zq4dj2w",
      token:
        "skUFzhBD3HmWQ8V2rkzW5Pq06JIJT6Rx5sCxgAhU0DO3yQm6sdFPg5zaLdKwiR2OAGya0VcN0hia3LYfRIp5h6W2Ydf1KaMK986tbX6hFxBbRuxkZ2lQVY9hHwjCJjRG9RrHnCFSFzMKzbbEn1BHOOUZHu868ZU5Fky2Hbd0qIHfSsrLw9Cv",
      dataset: process.env.GATSBY_SANITY_DEFAULT_DATASET,
    },
    functions: {
      endpoint: "https://api.gethommey.com",
      bis: "https://app.backinstock.org/stock_notification/create.json",
    },
    firebase: {
      apiKey: "AIzaSyBL8zCH0_NCSJZNGM67K6Jrj0Uj-Q7PBAc",
      authDomain: "hommey-website.firebaseapp.com",
      databaseURL: "https://hommey-website.firebaseio.com",
      projectId: "hommey-website",
      storageBucket: "hommey-website.appspot.com",
      messagingSenderId: "343593486249",
      appId: "1:343593486249:web:cc4b8da354e77b4218e6b8",
    },
    location: {
      serviceUrl: "https://ipapi.co/json/",
      countryFieldKey: "country",
      forceRegion: true,
    },
    reactify: {
      searchUrl: "https://api.search.reactify.app/",
      searchConfig: "https://config.search.reactify.app/?shop=hommey-store.myshopify.com",
      searchFieldKey: "q",
    },
    googleMaps: {
      apiKey: "",
    },
    facebook: {
      trackingId: "283187876321682",
    },
    okendo: {
      writeReviewUrl: "https://reviews.okendo.io/stores/568385c4-5eb5-458f-8441-63e2764a8d3f/review",
    },
  },
  queries: {
    blogs: {
      query: `allSanityArticle{ edges{ node { _id slug { current } } } }`,
      template: `templates/article.tsx`,
    },
    categories: {
      query: `allSanityArticleCategory{ edges{ node { _id slug { current } } } }`,
      template: `templates/category.tsx`,
    },
    products: {
      query: `allSanityProduct(filter: {shopify: {shopifyDeleted: {ne: true}, shopifyPublished: {eq: true}}}) { edges { node { tags, shopify { handle: shopifyHandle, shopifyRaw, deleted: shopifyDeleted, published: shopifyPublished }   } } }`,
      template: "templates/product.tsx",
      hidden: "hidden",
      parentTagPrefix: "",
      siblingTagPrefix: "styleGroup:",
      groupTagPrefix1: "productGroup:",
      groupTagPrefix2: "packGroup:",
      devPageLimit: 0,
    },
    collections: {
      query: `allSanityCollection(filter: {shopify: {shopifyDeleted: {ne: true}, shopifyPublished: {eq: true}}}) { edges { node { shopify {  handle: shopifyHandle, deleted: shopifyDeleted, published: shopifyPublished } parent: parentCollection { shopify { handle: shopifyHandle, deleted: shopifyDeleted, published: shopifyPublished } parent: parentCollection {  shopify { handle: shopifyHandle, deleted: shopifyDeleted, published: shopifyPublished } } }  } } }`,
      template: "templates/collection.tsx",
      hidden: "hidden",
      devPageLimit: 100,
    },
    flexible: {
      query: `allSanityPageFlexible { edges { node { _id slug { current } } } }`,
      template: "templates/flexible.tsx",
    },
    generic: {
      query: `allSanityPageGeneric { edges { node { _id slug { current } } } }`,
      template: "templates/generic.tsx",
    },
    redirects: {
      query: `allSanityRedirect { edges { node { source type destination } } }`,
      devPageLimit: 0,
    },
    robots: {
      query: `allSanitySettingRobots { nodes { content { code } } }`,
    },
  },
  settings: {
    keys: {
      shopify: "headless:shopify",
      country: "headless:country",
      location: "headless:location",
      checkout: "headless:checkout",
      discounts: "headless:discounts",
      customer: "headless:customer",
      wishlist: "headless:wishlist",
      announcement: "headless:announcement",
      maintenance: "headless:maintenance",
      password: "headless:password",
    },
    params: {
      continue: "return",
      customer: "key",
      giftcard: "redeem",
      variant: "variant",
      wishlist: "id",
    },
    routes: {
      HOMEPAGE: "/",
      FLEXIBLE: "",
      GENERIC: "",
      PAGE: "",
      BLOG: "/articles",
      CART: "/cart",
      CATEGORY: "/category",
      CONTACT: "/contact",
      SEARCH: "/search",
      PASSWORD: "/password",
      LOGIN: "/account/login",
      REGISTER: "/account/register",
      FORGOT: "/account/forgot",
      RESET: "/account/reset",
      ACTIVATE: "/account/activate",
      DASHBOARD: "/account",
      ORDERS: "/account/orders",
      ADDRESSES: "/account/addresses",
      PREFERENCES: "/account/preferences",
      PRODUCT: "/products",
      COLLECTION: "/collections",
      QUIZ: "/quiz",
    },
    defaultRedirects: [
      { source: "/collection", destination: "/collections", type: 301 },
      { source: "/checkout", destination: "/cart", type: 301 },
      { source: "/home", destination: "/", type: 301 },
    ],
    clientPaths: ["/account/reset/*", "/account/activate/*", "/account/orders/*"],
    sitemapExclusions: [
      "/offline-plugin-app-shell-fallback",
      "/dev-404-page",
      "/404",
      "/404.html",
      "/password",
      "/preview",
      "/account",
      "/account/login",
      "/account/forgot",
      "/account/activate",
      "/account/reset",
      "/account/orders",
      "/account/addresses",
      "/account/preferences",
      "/search",
      "/cart",
      "/cart/login",
    ],
  },
}
